import React,{useEffect, useState} from 'react'
import { toast } from 'react-hot-toast'
import {  ButtonFilledAutoWidth } from '../../components/button'
import { TextInput } from '../../components/input'
import { useNavigate, useLocation } from 'react-router-dom'
import GoBack from '../../components/back/GoBack'
import { addDriveCredential, getDriveCredentials, updateDriveCredential } from '../../services/driveCredentialService'
import SettingsMenu from '../staticscreens/SettingsMenu'

function DriveCredentialsCE() {
 
  const [data,setdata] = useState({clientId:'',clientSecret:'',apiKey:'',scopes:''});  
  const [error,seterror] = useState({clientId:'',clientSecret:'',apiKey:'',scopes:''}); 
  
  const {state} = useLocation();
  const navigate = useNavigate();



  useEffect(()=>{
    getdata()
  },[state])

  async function getdata() {
    const response = await getDriveCredentials()
    if(response?.length > 0){
      setdata({...response[0]})
    }
  }

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }

  async function submitform(){
    if(!data.clientId){
        seterror({...error,clientId:'Role Name field is required *'})
    }else if(!data.clientSecret){
      seterror({...error,clientSecret:'Display Name field is required *'})
    }else if(!data.apiKey){
      seterror({...error,apiKey:'Display Name field is required *'})
    }else if(!data.scopes){
      seterror({...error,scopes:'Display Name field is required *'})
    }else{
        if(data?._id === undefined || data?._id === null){
        const response = await addDriveCredential(data)
        // if (response.status === 200) {
          toast.success('Drive Credentials Created Successfully')
        // }   
      }else{
        let send_data = {...data}
        send_data["id"] = data?._id
        const response = await updateDriveCredential(data?._id,send_data)
        // if (response.status === 200) {
          toast.success('Drive Credentials Updated Successfully')
        // }   
      }
  }
  }

  

  return (
    <div className='md:flex '>

    <div className='hidden md:block'>
    <SettingsMenu />
    </div> 
 
  <div className='sm:w-full lg:w-72 px-4 pt-5' >


      <GoBack /> 
      
      

        <h6 className='font-bold'>{(data?._id !== null && data?._id !== undefined) ? 'Edit' : 'Add'}  Drive Credentials</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b> Drive Credentials</b> for your company employees to access there features.</h6>
     

        <TextInput 
            label={'ClientId'}  
            variant="standard"
            name="clientId"
            type="text"
            error={error.clientId}
            value={data.clientId}
            handlechange={handlechange}
            placeholder="Enter your Role name"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

        <TextInput 
            label={'Client Secret'}  
            variant="standard"
            name="clientSecret"
            type="text"
            error={error.clientSecret}
            value={data.clientSecret}
            handlechange={handlechange}
            placeholder="Enter your Display name"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

         <TextInput 
            label={'Api Key'}  
            variant="standard"
            name="apiKey"
            type="text"
            error={error.apiKey}
            value={data.apiKey}
            handlechange={handlechange}
            placeholder="Enter your Display name"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

         <TextInput 
            label={'Scopes'}  
            variant="standard"
            name="scopes"
            type="text"
            error={error.scopes}
            value={data.scopes}
            handlechange={handlechange}
            placeholder="Enter your Display name"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>        

<div className='mt-5'>
        <ButtonFilledAutoWidth btnName={(data?._id !== null && data?._id !== undefined) ? "UPDATE CREDENTIALS" : "ADD CREDENTIALS"}  onClick={submitform} />  
        </div>


    </div>
    </div>
  )
}

export default DriveCredentialsCE